<template>
  <div id="app">

 <div >
      <TheHeader></TheHeader>
        <router-view></router-view>
 </div>

  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader'

export default {
  name: 'app',
  metaInfo: {
    titleTemplate: '%s - American Gods S2 Presskit', // title is now "My Example App - Yay!"
    htmlAttrs: {
      lang: 'en'
    }
  },
  components: {
    TheHeader
  }
}
</script>

<style lang="scss">

  @import "styles/Global.scss";
</style>


// WEBPACK FOOTER //
// src/App.vue